//packages
import React from 'react';
import ReactSVG from 'react-svg';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Swal from 'sweetalert2';

import AddChild from './AddChild';

//icons
import deleteTable from '../../../components/Icons/close.svg';

//css
import '../ProfilePage.css';
import { connect } from 'react-redux';
import TableMaterial from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Delete, Edit, PersonAdd } from '@material-ui/icons';
import {
  clearChildData,
  getChild,
  delChildFromTable
} from '../../../redux/actions/childAction';
import { compose } from 'redux';
import { CompletedContext } from './StepperComponent';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#2D5CA6',
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14,
    paddingTop: 0,
    paddingBottom: 0
  }
}))(TableCell);

const Toast = Swal.mixin({
  toast: true,
  position: 'top-center',
  showConfirmButton: false,
  timer: 10000,
  customClass: {
    title: 'title-class'
  }
});

const styles = theme => ({
  disabled: {
    background: '#C2C5CB'
  },
  root: {
    padding: '0px'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
});
const useCompleted = () => {
  const contextValue = React.useContext(CompletedContext);
  return contextValue;
};
const TableChildren = props => {
  const [open, setOpen] = React.useState(false);
  const [child_id, setChildId] = React.useState(0);
  const [completed, dispatch] = useCompleted();
  const handleClickOpen = () => {
    setOpen(true);
    setChildId(0);
    props.clearChildData();
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClick = id => {
    props.delChildFromTable(id);
  };
  const hadleEdit = id => {
    props.getChild(id);
    setOpen(true);
    setChildId(id);
  };

  // React.useEffect(() => {
  //   const newCompleted = completed;
  //   if (
  //     props.children.length > 0
  //   ) {
  //     // newCompleted[props.activeStep] = true;
  //     // props.setCompleted(newCompleted);
  //     // props.handleNext();
  //     // dispatch({ type: 'COMPLETED', payload: newCompleted });
  //     // console.log('true', newCompleted);
  //   } else {
  //     // const newCompleted = props.completed;
  //     newCompleted[props.activeStep] = false;
  //     // props.setCompleted(newCompleted);
  //     dispatch({ type: 'COMPLETED', payload: newCompleted });
  //     // console.log('false', newCompleted);
  //   }
  // }, [props.children])

  const { classes } = props;
  // console.log(props.children);
  
  let childrenLarge = null;
  if (props.children.length !== 0) {
    childrenLarge = props.children.map((item, i) => {
      return (
        <TableRow key={i}>
          <StyledTableCell>{i + 1}</StyledTableCell>
          <StyledTableCell>
            {item.series} {item.documentnumber}
          </StyledTableCell>
          {/* <StyledTableCell></StyledTableCell> */}
          <StyledTableCell>{item.adopted_date}</StyledTableCell>

          <StyledTableCell>
            {/* <ChangeChild eusign={this.props.euSign} childData={item} /> */}
            <IconButton
              size="small"
              color="primary"
              onClick={() => hadleEdit(item.id)}
            >
              <Edit />
            </IconButton>
          </StyledTableCell>

          <StyledTableCell>
            <IconButton
              size="small"
              color="primary"
              className="ml-4"
              onClick={() => handleClick(item.id)}
            >
              <Delete />
            </IconButton>
          </StyledTableCell>
        </TableRow>
      );
    });
  } else {
    childrenLarge = (
      <TableRow>
        <StyledTableCell colSpan="6" className="text-center">
          <h4>
            <strong>Ви не додали жодної дитини</strong>
          </h4>
        </StyledTableCell>
      </TableRow>
    );
  }

  return (
    <React.Fragment>
      <Grid direction="row" container>
        <Grid item xs={12}>
          <div className="container-fluid m-0 p-0 ">
            {/* {this.props.children.length > 0 && ( */}
            <Button
              color="primary"
              type="submit"
              className=" ml-md-3 btn100"
              onClick={handleClickOpen}
              // disabled={(this.props.applications[0] || {}).state_code >= 20}
            >
              <PersonAdd className="mr-1" />
              Додати дитину
            </Button>
            <AddChild
              child_id={child_id}
              eusign={props.euSign}
              open={open}
              onClose={handleClose}
            />
            <div className="table-responsive ml-md-3 mr-md-3 mb-3">
              <TableMaterial>
                {/* <TableMaterial className="table table-border "> */}
                <TableHead>
                  <TableRow>
                    <StyledTableCell>№ з/п</StyledTableCell>
                    <StyledTableCell>
                      Серія та номер свідоцтва
                    </StyledTableCell>
                    {/* <StyledTableCell style={{ width: '15%' }}>
                      Опіка\усиновлення{' '}
                    </StyledTableCell> */}
                    <StyledTableCell>Дата опіки</StyledTableCell>
                    <StyledTableCell>
                      Переглянути/Редагувати дані
                    </StyledTableCell>
                    <StyledTableCell>Видалити дані</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{childrenLarge}</TableBody>
                
              </TableMaterial>
            </div>
            {/* )} */}
          </div>
        </Grid>
      </Grid>
      <Grid direction="row" container spacing={2}>
        <Grid item xs={12}>
          {/* <Button
            disabled={props.activeStep === 0}
            onClick={props.handleBack}
            className="mr-2"
          >
            Назад
          </Button> */}
          {/* <Button
            variant="contained"
            color="primary"
            onClick={props.handleNext}
            className="mr-2"
          >
            Наступна
          </Button> */}
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  applicant: state.applicant,
  children: state.children.data,
  selectChildrenArr: state.children.selectChildrenArr,
  childrenSelected: state.children.childrenSelected,
  childrenByAppID: state.children.childrenByAppID,
  directories: state.directories
});

const enhance = compose(
  connect(mapStateToProps, { clearChildData, getChild, delChildFromTable }),
  withStyles(styles)
);

export default enhance(TableChildren);
